import styled from 'styled-components'

const Label = styled.label`
  position: absolute !important;
  overflow: hidden !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
`

const Span = styled.span.attrs(props => ({
  id: props.id
}))`
  position: absolute !important;
  overflow: hidden !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
`

export default { Label, Span }



// WEBPACK FOOTER //
// ./src/components/HiddenLabel/index.js